// redux 5: createStore vive como legacy_createStore (o setup manual com
// sessionService segue suportado); redux-thunk 3 exporta `thunk` nomeado.
import { legacy_createStore as createStore, applyMiddleware, compose } from "redux";
import { sessionService } from "redux-react-session";
import { thunk } from "redux-thunk";

import rootReducer from "./reducers/rootReducer";

const initialState = {};
const middlewares = [thunk];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  initialState,
    composeEnhancers(applyMiddleware(...middlewares))
);

sessionService.initSessionService(store);

export default store;
